import Select from 'react-select';
import React from 'react';
import AsyncSelect from 'react-select/async';
export const MultiselectComponent = ({
  id = 'select',
  options,
  onChange,
  isMulti = false,
  disabled,
  onFocus,
  noOptionsMessage,
  placeholder = '',
  ...rest
}) => {
  return (
    <Select
      id={id}
      options={options}
      onChange={onChange}
      isMulti={isMulti}
      isDisabled={disabled}
      onFocus={() => onFocus && onFocus(id)}
      noOptionsMessage={noOptionsMessage}
      placeholder={placeholder || 'Select Categories...'}
      {...rest}
    />
  );
};

export const AsyncSelectComponent = ({
  id,
  loadOptions,
  onChange,
  isMulti = false,
  disabled = false,
  onFocus
}) => {
  return (
    <AsyncSelect
      autoFocus={false}
      id={id}
      cacheOptions
      loadOptions={loadOptions}
      onFocus={() => onFocus(id)}
      onChange={onChange}
      isMulti={isMulti}
      isDisabled={disabled}
    />
  );
};
